import { makeContext } from "../helpers";
export var initialUserIdentPool = {};
export var UserIdentPoolContextProvider = makeContext(initialUserIdentPool);
